import React, { Component } from "react";
import Button from "react-bootstrap-button-loader";
import {
  injectStripe,
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
} from "react-stripe-elements";

import LocaleStrings from "Languages";
import { Field } from "redux-form";

const handleBlur = () => {};
const handleChange = (change) => {};
const handleClick = () => {};
const handleFocus = () => {};
const handleReady = () => {};

class AddPayfastForm extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  componentDidMount() {}

  handleSubmit = (ev) => {
    var that = this;
    ev.preventDefault();

    // if (this.props.stripe) {
    //     this.props.stripe
    //         .createToken()
    //         .then((payload) =>
    //
    //         );
    // } else {

    // }

    this.setState({ loading: true });
    this.props.stripe.createToken().then(({ error, token }) => {
      if (error) {
        that.props.onTokenReceived(null, error);
        that.setState({ loading: false });
      } else {
        if (token) that.props.onTokenReceived(token, null);
        setTimeout(() => {
          that.setState({ loading: false });
        }, 10000);

        // that.setState({loading: false});
      }
    });
  };

  closeModal = () => {
    this.props.onCloseModal();
  };

  render() {
    let { showModal, callFrom, totalamount } = this.props;
    return (
      <div className="basicform">
        <form onSubmit={this.handleSubmit}>
          {/* IF CALLED FROM BILLING SECTION */}
          {this.props.callFrom == "accountsettings" ? (
            <>
              <label className="" style={{ fontWeight: 300 }}>
                {LocaleStrings.tickets_payfast_form_label_card_no}
                <CardNumberElement
                  className="customStripeCss-billing"
                  showIcon={true}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onReady={handleReady}
                />
              </label>
              <div className="d-flex">
                <label
                  className=""
                  style={{ fontWeight: 300, maxWidth: "50%" }}>
                  {LocaleStrings.tickets_payfast_form_label_expiry_date}
                  <CardExpiryElement
                    className="customStripeCss-billing-expiry"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onReady={handleReady}
                  />
                </label>

                <label
                  className=""
                  style={{
                    fontWeight: 300,
                    // marginLeft: "20px",
                    maxWidth: "50%",
                  }}>
                  {LocaleStrings.tickets_payfast_form_label_cvv}
                  <CardCVCElement
                    className="customStripeCss-billing-cvc"
                    showIcon={true}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    onFocus={handleFocus}
                    onReady={handleReady}
                    // {...createOptions(this.props.fontSize)}
                  />
                </label>
              </div>
              <div className="d-flex">
                <Button
                  className="btn btn-custom-white text-center"
                  style={{ width: "50%" }}
                  onClick={this.closeModal}>
                  Close
                </Button>
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="submit"
                  style={{ width: "50%" }}
                  loading={this.state.loading}>
                  {LocaleStrings.billing_payfast_form_btn_pay} ${totalamount}
                </Button>
              </div>
              <div
                className="text-center mt-4 "
                style={{ fontSize: "12px", color: "#8792A2" }}>
                {LocaleStrings.billing_payfast_form_text_powerd_by}
                <img className="ml-2" src="../../style/images/stripe.svg"></img>
                <span className="mx-4">|</span>
                <span>
                  <a href="https://eventify.io/terms-of-use" target="_blank">
                    {" "}
                    Terms & Privacy
                  </a>
                </span>
              </div>
            </>
          ) : (
            <>
              <label className="customStripeLabelCss">
                {LocaleStrings.tickets_payfast_form_label_card_no}
                <CardNumberElement
                  className="customStripeCss"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onReady={handleReady}
                  // {...createOptions(this.props.fontSize)}
                />
              </label>
              <label className="customStripeLabelCss">
                {LocaleStrings.tickets_payfast_form_label_expiry_date}
                <CardExpiryElement
                  className="customStripeCss"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onReady={handleReady}
                  // {...createOptions(this.props.fontSize)}
                />
              </label>
              <label className="customStripeLabelCss">
                {LocaleStrings.tickets_payfast_form_label_cvv}
                <CardCVCElement
                  className="customStripeCss"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onReady={handleReady}
                  // {...createOptions(this.props.fontSize)}
                />
              </label>
              <div className="text-right">
                <Button
                  className="btn btn-custom-white"
                  onClick={this.closeModal}>
                  {LocaleStrings.button_close}
                </Button>
                {/* {showModal.update && showModal.update == 'card' ? 
                  <Button className="btn btn-custom-blue ml-10" type="submit" loading={this.state.loading}>{LocaleStrings.button_save}</Button>
              : */}
                <Button
                  className="btn btn-custom-blue ml-10"
                  type="submit"
                  loading={this.state.loading}>
                  {LocaleStrings.button_save}
                </Button>
                {/* } */}
              </div>
            </>
          )}
        </form>
      </div>
    );
  }
}

export default injectStripe(AddPayfastForm);
